import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ReactstrapCardTitle as CardTitle, ReactstrapCol as Col, ReactstrapRow as Row } from '@febos-io/design';

import useTranslation from '../../hooks/useTranslation';
import { useSkin } from '../utility';
import '../core/scss/react/pages/page-authentication.scss';
import { useDesignContext } from '../../providers';

export function Login({ children }) {
  const { AppLogo, appName } = useDesignContext();
  const { loginImage } = useSkin();
  const { t } = useTranslation();

  return (
    <div className="auth-wrapper auth-cover">
      <Row className="auth-inner m-0">
        <Link
          className="brand-logo"
          to="/"
          onClick={(e) => e.preventDefault()}
        >
          <AppLogo />
          <h2 className="brand-text text-primary ms-1">{appName}</h2>
        </Link>
        <Col
          className="d-none d-lg-flex align-items-center p-5"
          lg="8"
          sm="12"
        >
          <div className="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <img
              className="img-fluid"
              src={loginImage}
              alt={appName}
            />
          </div>
        </Col>
        <Col
          className="d-flex align-items-center auth-bg px-2 p-lg-5"
          lg="4"
          sm="12"
        >
          <Col
            className="px-xl-2 mx-auto"
            sm="8"
            md="6"
            lg="12"
          >
            <CardTitle
              tag="h2"
              className="fw-bold mb-1"
            >
              {t('Welcome to')}
              {' '}
              {appName}
              ! 👋
            </CardTitle>
            {children}
            <div className="auth-footer-btn d-flex justify-content-center" />
          </Col>
        </Col>
      </Row>
    </div>
  );
}

Login.propTypes = {
  background: PropTypes.any,
  children: PropTypes.node
};

export default Login;
